import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

interface ErrorDisplayProps {
  error: string;
  onRetry?: () => void;
  fullScreen?: boolean;
}

/**
 * Error display component with optional retry functionality
 */
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ 
  error, 
  onRetry, 
  fullScreen = false 
}) => {
  const content = (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <FaExclamationTriangle className="text-red-500 text-5xl mb-4" />
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        We couldn't open this report
      </h3>
      <p className="text-gray-600 mb-4 max-w-md">{error}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="btn-primary"
        >
          Try Again
        </button>
      )}
      <p className="text-sm text-gray-500 mt-4">
        Need help? Contact{' '}
        <a
          href="mailto:mamabear@loonmd.com"
          className="text-blue-600 hover:text-blue-500"
        >
          mamabear@loonmd.com
        </a>
      </p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        {content}
      </div>
    );
  }

  return content;
};

export default ErrorDisplay;
